const modal = require(`modal`);
const loader = require(`loader`);
const notification = require(`notification`);
const drillSearchService = require(`drillSearchService`);
const freeTextSearch = require(`freeTextSearch`);
const buildContentTeaser = require(`buildContentTeaser`);
const wordCount = require(`wordCount`);
const userService = require(`userService`);

const mySessions = (function() {
  let session_title = null;
  let session_summary = null;
  let session_id = null;
  const query = null;
  let delete_session_title = null;
  let delete_session_id = null;
  const search_qty = `10`;
  const searchItem = null;
  const $toggleDropArea = $(`.btn.show-drop-area`);
  const $searchResultsPanel = $(`#draggables`);
  const $searchInput = $(`#drill_search`);
  const $searchForm = $(`#session-search`);
  const $contentMarkup = $(`#content-master-clone`);
  const $sessionDrillsWrapper = $(`#session-drills-wrapper`);
  const $warmupDisplay = $(`.warmup-display`);
  const $technicalDisplay = $(`.technical-display`);
  const $skillDisplay = $(`.skill-display`);
  const $gameDisplay = $(`.game-display`);
  let $deleteSession = null;
  let $deleteDrill = null;
  let newSessionID = null;

  const toggleDropArea = function() {
    $toggleDropArea.on(`click`, function() {
      $(`body`).toggleClass(`drop-area-open`);
      $(this).toggleClass(`rotate`);
    });
  };

  const createDragable = function() {
    const $draggables = $(`body`).find(`#draggables li`);
    const $dropZone = $(`.drop-target`);
    const $bonds = $(`body`);
    const overlapThreshold = `70%`;

    const tween = TweenMax.to($draggables, 0.4, {
      scale: 1,
      opacity: 1,
    });

    $(`.dragging a, #drop-area a`).on(`click`, function(e) {
      e.preventDefault();
    });

    const movingItemStart = function(el, speed) {
      return TweenMax.to(el, speed, {
        force3D: true,
        zIndex: 10,
        paused: true,
        scale: 0.8,
      });
    };

    const movingItemEnd = function(el, speed) {
      return TweenMax.to(el, speed, {
        force3D: false,
        scale: 1,
        zIndex: 0,
        paused: true,
      });
    };

    const foundTarget = function(el, speed) {
      return TweenMax.to(el, speed, {
        boxShadow: `rgba(0,0,0,0) 0px 0px 0px 0px`,
        scale: 0.8,
      });
    };

    const returnItem = function(el, speed) {
      return TweenMax.to(el, speed, {
        x: 0,
        y: 0,
      });
    };

    const scaleItem = function(el, speed) {
      return TweenMax.to(el, speed, {
        scale: 1,
        opacity: 1,
        zIndex: 0,
      });
    };

    Draggable.create($draggables, {
      dragClickables: true,
      throwProps: true,
      type: `x,y`,

      onDragStart(e) {
        $(this.target).addClass(`dragging`);
        const x = movingItemStart($(this.target), 0.4).play();
        $(`body`).addClass(`drop-area-open`);
      },

      onDrag(e) {
        for (let i = 0; i < $dropZone.length; i++) {
          if (this.hitTest($dropZone[i], overlapThreshold)) {
            const x = foundTarget($(this.target), 0.4).play();
            $($dropZone[i]).addClass(`show-over`);
          } else {
            $($dropZone[i]).removeClass(`show-over`);
          }
        }
      },

      onDragEnd(e) {
        for (let i = 0; i < $dropZone.length; i++) {
          const x = movingItemEnd($(this.target), 0.4).play();
          if (this.hitTest($dropZone[i], overlapThreshold)) {
            if (!$($dropZone[i]).hasClass(`fade-out`)) {
              const $item = $(this.target).children().clone();
              $item.appendTo($($dropZone[i]));
              $($dropZone[i]).addClass(`fade-out`).removeClass(`show-over`);
              $(`body`).addClass(`drop-area-open`);
              const j = returnItem($(this.target), 0).play();
              const y = scaleItem($(this.target), 0.4).play();
              const z = scaleItem($($dropZone[i]).parent(), 0.4).play();
              showSaveBtn();
            }
          } else {
            $(`body`).removeClass(`drop-area-open`);
            const w = returnItem($(this.target), 0.4).play();
          }
        }
        $(this.target).removeClass(`dragging`);
      },
    });
  };

  const navigation = function() {
    $(document).on(`click`, `#sessions-list .teaser-actions .view`, function() {
      pageToggle();
      session_title = $(this).parents(`.content-teaser`).find(`.teaser-title`).html();
      session_summary = $(this).parents(`.content-teaser`).find(`.teaser-summary`).html();
      session_id = $(this).parents(`.toggle-btns`).attr(`data-model-id`);
      updateDisplayContent();

      showEditBtn();
      $(`.back-btn`).toggle();
    });

    $(`.my-sessions-page-header .back-btn`).on(`click`, function() {
      pageToggle();
      $(`body`).removeClass(`drop-area-open`);
      $sessionDrillsWrapper.html(``);
      $(`#edit-session-form`).hide();
      $(`.edit-hide`).show();
      resetBtns();
    });

    $(`.edit-details`).on(`click`, function() {
      $(`.edit-hide`).hide();
      $(`#edit-session-form`).show();
      $(`.show-drop-area`).show();
      showSaveBtn();
    });
  };


  const createNew = function() {
    if (!$(`#page-2`).hasClass(`active`)) {
      pageToggle();
    }

    $(`.create-new`).hide();
    $(`.edit-hide`).hide();
    $(`#edit-session-form`).show();
    $(`.show-drop-area`).show();
    $(`.back-btn`).show();
    showSaveBtn();
    clearContent();
  };


  var clearContent = function() {
    $(`#session-title`).html(``);
    $(`#session_name`).val(``);
    $(`#session_summary`).val(``);
    $(`.drop-target .content-teaser`).remove();
    $(`.drop-target`).removeClass(`fade-out`);
    session_summary = null;
    session_id = null;
  };

  var showSaveBtn = function() {
    $(`.edit-details`).hide();
    $(`.save-details`).show();
    $(`.create-new`).hide();
    $(`.search-results`).show();
  };

  var showEditBtn = function() {
    $(`.save-details`).hide();
    $(`.edit-details`).show();
    $(`.create-new`).hide();
    $(`.search-results`).hide();
  };

  var resetBtns = function() {
    $(`.back-btn`).hide();
    $(`.edit-details`).hide();
    $(`.save-details`).hide();
    $(`.show-drop-area`).hide();
    $(`.create-new`).show();
    $(`#edit-session-form`).hide();
    $(`.edit-hide`).show();
    $(`.my-sessions-page-header .back-btn.hidden-sm-down`).text(`Back`);
  };

  var updateDisplayContent = function() {
    $(`#session-title`).html(session_title);
    $(`#session_name`).val(session_title);
    $(`#session_summary`).val(session_summary);
    getSessionDrillsService(session_id, getSessionDrillsResponse);
  };

  var getSessionDrillsResponse = function(response) {
    if (response.statusCode === 200) {
      $(`window`).buildContentTeaser(response, response.data.drills, $contentMarkup, $sessionDrillsWrapper, true);
      $.each(response.data.drill_map, function(key, content) {
        if ((content).length !== 0) {
          $(`.${key}-display`).attr(`data-content-id`, content);
          resetDisplayContent();
        }
      });
    } else {
      $(`window`).notification({ title: response.message, error: true });
    }
  };

  var resetDisplayContent = function() {
    $(`.drill-display .content-teaser`).remove();
    $(`.drill-display`).removeClass(`fade-out`);
    cloneDrillsIntoDropZones();
  };

  var cloneDrillsIntoDropZones = function() {
    const itemClone = function($item, $target) {
      if ($item.length) {
        $item.addClass(`transform-item`);
        $target.addClass(`fade-out`);
        const $ClonedItem = $item.clone();
        $ClonedItem.appendTo($target);
      }
    };

    const $drillWarmup = $(`#session-drills-wrapper`).find(`[data-content-id='${$warmupDisplay.attr(`data-content-id`)}']:first`);
    const $drillTechnical = $(`#session-drills-wrapper`).find(`[data-content-id='${$technicalDisplay.attr(`data-content-id`)}']:first`);
    const $drillSkill = $(`#session-drills-wrapper`).find(`[data-content-id='${$skillDisplay.attr(`data-content-id`)}']:first`);
    const $drillGame = $(`#session-drills-wrapper`).find(`[data-content-id='${$gameDisplay.attr(`data-content-id`)}']:first`);

    itemClone($drillWarmup, $warmupDisplay);
    itemClone($drillTechnical, $technicalDisplay);
    itemClone($drillSkill, $skillDisplay);
    itemClone($drillGame, $gameDisplay);
  };

  var pageToggle = function() {
    $.each($(`.page`), function() {
      $(this).toggleClass(`active`);
    });
  };

  const drillSearch = function() {
    $(`window`).freeTextSearch($searchForm, searchDrillsAPI);
  };

  var searchDrillsAPI = function() {
    $(`.page-content`).css(`height`, `auto`);
    const search_term = $searchInput.val();
    searchDrillsService(search_term, search_qty, removeSearchResults);
  };

  var removeSearchResults = function(response) {
    const $draggables = $(`body`).find(`#draggables > li`);
    if ($draggables.length) {
      const tween = TweenMax.to($draggables, 0.4, {
        scale: 0,
        opacity: 0,
      });
      setTimeout(function() {
        searchDrillResults(response);
      }, 500);
    } else {
      searchDrillResults(response);
    }
  };

  var searchDrillResults = function(response) {
    $searchResultsPanel.html(``);
    $searchForm.removeClass(`searching`);
    if (response.statusCode === 200) {
      if ((response.data.json).length === 0) {
        $(`.search-results`).removeClass(`default`).addClass(`no-results`);
        $(`.no-results h2 span`).html($searchInput.val());
      } else {
        $(`.search-results`).removeClass(`default no-results`);
        $(`window`).buildContentTeaser(response, response.data.json, $contentMarkup, $searchResultsPanel, true);
        createDragable();
      }
    } else {
      $(`.search-results`).addClass(`no-results`);
    }
  };

  const formValidation = function() {
    $(`#sessions-form`).validate({
      rules: {
        session_name: {
          required: true,
          maxlength: 200,
        },
        session_summary: {
          maxlength: 1000,
        },
        has_drill: {
          required: true,
        },
      },
      submitHandler() {},
    });

    $(`#session_name`).limiter(200, $(`#session_name_counter`));
    $(`#session_summary`).limiter(1000, $(`#session_summary_counter`));
  };

  const checkSessionExists = function() {
    $(`.save-details`).on(`click`, function() {
      if ($(`#sessions-form`).valid()) {
        if ($(`.drop-target`).hasClass(`fade-out`)) {
          if (!$(this).hasClass(`clicked-link`)) {
            $(this).addClass(`clicked-link`);
            $(`window`).showLoader();
            session_title = $(`#session_name`).val();
            session_summary = $(`#session_summary`).val();
            if (session_id === null) {
              session_id = 0;
            }
            checkSessionExistsService(session_title, session_id, checkSessionExistsResponse);
          }
        } else {
          $(`window`).notification({ title: `Sessions require at least one drill`, error: true });
        }
      }
    });
  };

  var checkSessionExistsResponse = function(response) {
    $(`.save-details`).removeClass(`clicked-link`);
    if (response.statusCode === 200) {
      updateOrCreate();
    } else {
      $(`window`).notification({ title: response.message, error: true });
    }
  };

  var updateOrCreate = function() {
    const warmupID = $(`.drop-target.warmup-display .content-teaser`).attr(`data-content-id`);
    const technicalID = $(`.drop-target.technical-display .content-teaser`).attr(`data-content-id`);
    const skillID = $(`.drop-target.skill-display .content-teaser`).attr(`data-content-id`);
    const gameID = $(`.drop-target.game-display .content-teaser`).attr(`data-content-id`);

    const drill_map = {};
    drill_map.warmup = warmupID || ``;
    drill_map.technical = technicalID || ``;
    drill_map.skill = skillID || ``;
    drill_map.game = gameID || ``;

    const item = {};
    item.session_id = session_id;
    item.title = session_title;
    item.summary = session_summary;
    item.drill_map = drill_map;

    const data = JSON.stringify(item);

    if (session_id === null || session_id === 0) {
      createSessionService(data, sessionServiceResponse);
    } else {
      editSessionService(data, sessionServiceResponse);
    }
  };

  var sessionServiceResponse = function(response) {
    if (response.statusCode === 200) {
      $(`window`).notification({ title: response.message });
      pageToggle();
      newSessionID = response.data.id;
      updateSessionCheck();
      resetBtns();
      buildTempSession();
    } else {
      $(`window`).notification({ title: response.message, error: true });
    }
  };

  var updateSessionCheck = function() {
    if ($(`#sessions-list`).find(`[data-content-id='${session_id}']`).length) {
      $deleteSession = $(`#sessions-list`).find(`[data-content-id='${session_id}']`);
      deleteAnimation();
    }
  };

  var buildTempSession = function() {
    const author = $(`.user-teaser .teaser-title`).html();
    const drillCount = $(`.drop-target .content-teaser`).length;
    const $tempSessionWrapper = $(`#sessions-list`);
    let imageURL = $(`.drop-area .content-teaser .teaser-thumbnail`).css(`background-image`);
    const builtSessionUrl = `/session/${newSessionID}`;
    imageURL = imageURL.replace(/^url\(["']?/, ``).replace(/["']?\)$/, ``);
    const session = [
      {
        id: newSessionID,
        title: session_title,
        author_full_name: author,
        drill_count: drillCount,
        type: `session`,
        plaintext_summary: session_summary,
        thumbnail_image_url: imageURL,
        slug: builtSessionUrl,
      },
    ];

    const data = JSON.stringify(session);
    $(`window`).buildContentTeaser(data, session, $contentMarkup, $tempSessionWrapper);
    sessionCount();
  };

  const deleteSession = function() {
    $(document).on(`click`, `#sessions-list .teaser-actions .remove`, function(e) {
      e.preventDefault();
      delete_session_title = $(this).parents(`.content-teaser`).find(`.teaser-title`).html();
      $deleteSession = $(this).parents(`.content-teaser`);
      delete_session_id = $(this).parent().attr(`data-model-id`);
      $(`window`).modal({
        title: `Delete ${delete_session_title}?`,
        content: `<p>Are you sure you want to delete this session? This action cannot be undone.</p>`,
        confirmText: `Delete`,
        complete() {
          deleteSessionService(delete_session_id, deleteSessionServiceResponse);
        },
      });
    });
  };

  var deleteSessionServiceResponse = function(response) {
    if (response.statusCode === 200) {
      deleteAnimation();
      $(`window`).notification({ title: `Session has been deleted` });
    } else {
      $(`window`).notification({ title: response.message, error: true });
    }
  };

  var deleteAnimation = function() {
    const tween = TweenMax.to($deleteSession, 0.4, {
      scale: 0,
      opacity: 0,
      onComplete: deleteItem,
    });

    function deleteItem() {
      $deleteSession.parent().remove();
      sessionCount();
    }
  };

  var sessionCount = function() {
    if ($(`#sessions-list .content-teaser`).length == `0`) {
      $(`.no-sessions-message`).show();
    } else {
      $(`.no-sessions-message`).hide();
    }
  };


  const checkIfCanCreateSession = function(res) {
    const computedAccess = res.data.computed_access;
    const orgId = res.data.org_id;
    let accessAll = false;
    console.log(`OrgId:${orgId}`);
    if (orgId === 9 || orgId === `9`) {
      accessAll = true;
    }
    $(`.create-new`).on(`click`, function(e) {
      if (accessAll === true || computedAccess === `coach_club` || computedAccess === `coach_team` || computedAccess === `enterprise` || computedAccess === `premium`) {
                // Allow Session functions to run
        createNew();
      } else {
        e.preventDefault();
        // If user is logged in but isn't an allowed user
        const serverUsingNewPlans = $(`#my-sessions`).data(`serverUsingNewPlans`);
        if (serverUsingNewPlans === true) {
          var accessLevels = [`Premium`, `Enterprise`];
        } else {
          var accessLevels = [`Team`, `Club`];
        }
        if (computedAccess) {
          $(window).modal({
            title: `Hold on a minute...`,
            content: `<p>The Session Creator is currently only available for <strong>${accessLevels[0]}</strong> or <strong>${accessLevels[1]}</strong> users. It's quick and easy to upgrade, simply click the upgrade button below to view our plans and choose the option that suits you best.</p>`,
            confirmText: `Upgrade your plan`,
            complete() {
              window.location.href = `/locker/profile/edit-profile?select=change-plan`;
            },
          });
        }
      }
    });
  };


  const deleteDrill = function() {
    $(document).on(`click`, `#drop-area .teaser-actions .remove`, function(e) {
      e.preventDefault();
      $deleteDrill = $(this).closest(`.content-teaser`);
      const tween = TweenMax.to($deleteDrill, 0.4, {
        scale: 0,
        opacity: 0,
        onComplete: deleteItem,
      });

      function deleteItem() {
        $deleteDrill.parent().removeClass(`fade-out`);
        $deleteDrill.remove();
        showSaveBtn();
      }
    });
  };


  const createNewSessionCTA = function() {
    getLoggedInUserService(checkIfCanCreateSession);
  };


  const init = function() {
    createNewSessionCTA();
    navigation();
    toggleDropArea();
    drillSearch();
    formValidation();
    checkSessionExists();
    deleteSession();
    deleteDrill();
  };

  return { init };
}());

if ($(`#my-sessions`).length) {
  mySessions.init();
}



// WEBPACK FOOTER //
// ./library/js/modules/my-sessions.js